export default __webpack_public_path__ + "static/andy2-17b95b37c3a16079e684a934c4c82920.png";